import styles from './App.module.scss';
import { useGlobal } from './store/useGlobal';
import { DesktopShell } from './shell/DesktopShell';
import { MobileShell } from './shell/MobileShell';
import { UpdateBanner } from './shell/UpdateBanner';
import { NotifyPopups } from './shell/NotifyPopups';
import { ServerErrorToast } from './shell/ServerErrorToast';

export function App() {
  const { isMobile, isStandalone } = useGlobal((s) => s.layout);
  // data-auth 是 e2e 的 Worker 链路锚点：变成 logged-out/logged-in = auth/state 已回包
  const authStatus = useGlobal((s) => s.auth.status);
  return (
    <div
      className={styles.shell}
      data-layout={isMobile ? 'mobile' : 'desktop'}
      data-standalone={isStandalone ? 'true' : 'false'}
      data-auth={authStatus}
    >
      {isMobile ? <MobileShell /> : <DesktopShell />}
      {/* 新版本提示条（15b）：固定覆盖层，两端同一套，与当前页面无关 */}
      <UpdateBanner />
      {/* 窗口内新消息提示条（18c2b）：右下角固定覆盖层，仅桌面出，与当前页面无关 */}
      <NotifyPopups />
      {/* 无归属的服务端错误 toast（21f）：与当前页面无关，两端都出 */}
      <ServerErrorToast />
    </div>
  );
}
